import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Paginator } from 'primeng/paginator';
import { FormGroup, FormBuilder, NgForm, Validators } from "@angular/forms";
import { EditorComponent } from "@progress/kendo-angular-editor";
import { map, concatMap, take, first, switchMap } from 'rxjs/operators';
import { from, of, Subscription } from "rxjs";
import { ToastrService } from 'ngx-toastr';
import { EmailClientService } from "../service/email-client.service";
import { GoogleApiService } from "../../scheduling/google-api.service";
import { catchError } from 'rxjs/internal/operators/catchError';
import { CustomErrorToastComponent } from "custom-error-toast";

@Component({
  selector: "google-email-client-table",
  templateUrl: "./google-email-client-table.component.html",
  styleUrls: ["./google-email-client-table.component.scss"],
})
export class GoogleEmailClientTableComponent implements OnInit, OnChanges {
  @Output() @ViewChild("commonkendoeditor") public commonkendoeditor: EditorComponent;
  @ViewChild('froalaForm', { static: true })
  froalaForm: NgForm;
  @Input() formControlName: string | 'floraEditor';
  commonkendoeditorStr: string;
  @ViewChild('paginator', { static: true }) paginator: Paginator;
  // @Input("emailType") emailType: string;
  @Input("headerActionType") headerActionType: string;
  @Input("emailClientTableList") emailClientTableList: any = null;
  @Input("emailMessageCount") totalRecords: number = 0;
  @Input("isEmailClientTable") isEmailClientTable: boolean;
  @Input('isDisableObject') isDisableObject: any;
  @Output() onChangeTableRowData = new EventEmitter<any>();
  @Output() onGmailPaginationChange = new EventEmitter<any>();
  @Output() deleteMailSection = new EventEmitter<any>();
  @Output() onGmailLabelAdd = new EventEmitter<any>();
  @Output() onChangeFolder = new EventEmitter<boolean>();
  isSaveSection: boolean = false;
  googleLabelsModal: boolean = false;
  googleMoveModal: boolean = false;
  selectedRows: any[];
  gmailLabelDropdownList: any[] = [];
  emailArrSubscription: Subscription;
  emailType: string;
  submitted: boolean = false;
  googleMessageType: string;
  labelForm: FormGroup;
  labelDropdownForm: FormGroup;
  isMovingtoSameLabel: boolean;
  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    public googleApi: GoogleApiService,
    public emailClientService: EmailClientService) {
    this.labelForm = this.fb.group({
      label: ['', [Validators.required]],
    });
    this.labelDropdownForm = this.fb.group({
      labeldropdown: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.selectedRows = [];
    this.emailArrSubscription = this.googleApi.emailArrSubscription$.subscribe((emailArr: string[]) => {
      if (emailArr) {
        this.selectedRows = emailArr;
        this.deleteGoogleEmails();
        this.emailArrSubscription.unsubscribe();
      }
    })
    this.googleMessageType = this.googleApi.googleMessageType ? this.googleApi.googleMessageType : 'INBOX';
    this.getCreatedLabels();
  }

  checkContainObject(selectedRows): boolean {
    return selectedRows.some((value: any) => { return typeof value == "object" });
  }

  async getCreatedLabels() {
    const userId = this.getUserInformation().info.email;
    try {
      await this.googleApi.getFolders(userId).pipe(
        map((folders: any) => {
          return folders?.labels?.filter((folder: any) => folder.name.includes("IM-"))
        })).toPromise().then(
          data => {
            this.gmailLabelDropdownList = data;
          }
        )
    } catch (error) {
      if (error.error.error.status === "UNAUTHENTICATED") {
        this.googleApi.login().then(() => { });
      }
    }
  }




  onCreateLabel() {
    this.submitted = true;
    if (this.labelForm.valid) {
      const userId = this.getUserInformation().info.email;
      let labelData = this.labelForm.value;
      let data = {
        "labelListVisibility": "labelShow",
        "messageListVisibility": "show",
        "name": "IM-" + labelData?.label?.trim(),
        "type": "user"
      }

      this.googleApi.createLabel(userId, data).subscribe(
        message => {
          if (message.status === 200) {
            this.toastr.success("Label created successfully.", 'Success');
            // dispaly to left side menu 
            this.onGmailLabelAdd.emit(true);
          }
        },
        error => {
          CustomErrorToastComponent.showErrorToast(this.toastr, error?.error?.error?.message);
        }
      )
      this.googleLabelsModal = false;
      this.labelForm.reset();
    }
  }

  createLabel() {
    this.googleLabelsModal = true;
  }

  getUserInformation() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    return userInfo;
  }

  deleteGoogleEmails() {
    this.googleMessageType = this.googleApi.googleMessageType;
    //when delete click on this page
    if (this.checkContainObject(this.selectedRows)) {
      this.selectedRows = this.selectedRows.map(data => {
        if (data) return data.threadId || data.messageId;
      });
    }
    if (this.selectedRows.length) {
      const userId = this.getUserInformation().info.email;
      from(this.selectedRows).pipe(
        concatMap(threadId => {
          if (threadId) {
            return this.googleMessageType == "TRASH" ?
              this.googleApi.deleteEmailPermanently(userId, threadId).pipe(
                catchError(error => {
                  return of([]);
                }))

              :
              this.googleApi.moveEmailToTrash(userId, threadId).pipe(
                switchMap(res => res.status === 204 ? of(res.status) : of(res))
              )
          }
          else {
            of([]);
          }
        }
        ))
        .subscribe((message: any) => {
          if ((message.status === 200 || message.status === 204) && this.googleMessageType != "TRASH") {
            this.toastr.success("Email deleted successfully.", 'Success');
            this.emailClientService.folderChangeSubject$.next(true);
          }
          else {
            this.toastr.success("Email deleted permanently.", 'Success');
            this.emailClientService.folderChangeSubject$.next(true);
          }
        },
          (error) => {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while deleting email.');
          })
      this.selectedRows = [];
    }
    else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select email(s) to delete.');
    }
  }

  async onMove() {
    let selectedValLabel = this.gmailLabelDropdownList.find(x => x.id === this.labelDropdownForm.value.labeldropdown).id;
    if (this.emailClientService.outlookMessageType === selectedValLabel) {
      this.isMovingtoSameLabel = true;
    } else {
      this.isMovingtoSameLabel = false;
      this.submitted = true;
      if (this.labelDropdownForm.valid) {
        const userId = this.getUserInformation().info.email;
        let labelData = this.labelDropdownForm.value;
        // this.messageType = this.emailClientService.outlookMessageType;
        let foldernameId = labelData?.labeldropdown;
        if (this.selectedRows.length) {
          from(this.selectedRows).pipe(
            map(data => data.id),
            concatMap(threadId => {
              let requestBody = {
                "addLabelIds": [
                  foldernameId
                ],
                "removeLabelIds": [
                  this.googleApi.googleMessageType
                ]
              };
              return this.googleApi.moveThreads(requestBody, userId, threadId);
            }
            ))
            .subscribe((message: any) => {
              if (message.status === 200) {
                this.toastr.success("Email moved successfully.", 'Success');
                this.googleMoveModal = false;
                this.getCreatedLabels();
                this.onChangeFolder.emit(true);
                this.selectedRows = [];
              }
            },
              (error) => {
                this.onChangeFolder.emit(true);
                CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while moving email.');
              })
        }
        else {
          CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select email(s) to move.');
        }
      }
    }
  }

  moveEmails() {
    this.labelDropdownForm.reset();
    if (this.selectedRows.length) {
      this.googleMoveModal = true;
    }
    else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select email(s) to move.');
    }
  }

  onChangeSubTaskType(param) {
    if (param.value === "reply") {
      this.isEmailClientTable = false;
      this.isSaveSection = true;
      this.onChangeTableRowData.next(this.isEmailClientTable);
    }
  }

  handleSelect(e, param) {
    this.onChangeTableRowData.next(param);
    // this.emailClientService.emailDetailSubscription$.next({read:true,emailType:this.emailTypegggggg});
    this.emailClientService.emailDetailSubscription$.next({ read: true });
    this.googleMessageType = this.googleApi.googleMessageType;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedRows = []; // to remove selected checkbox after switching to folder like Inbox, Draft
    this.emailClientTableList = changes.emailClientTableList.currentValue;
  }
  // deleteMail(data) {
  //   this.deleteMailSection.next(data);
  // }

  next() {
    this.onGmailPaginationChange.emit('next');
  }

  prev() {
    this.onGmailPaginationChange.emit('prev');
  }
}